import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { DateOnly } from "@/Common/Utilities/DateAndTime/DateOnly";
import { TimeInterval } from "@/Common/Utilities/DateAndTime/TimeInterval";
import { HyperLinkControl } from "../Buttons/HyperLinkControl";

interface IShorthandDateSetterProps {
    dataCy?: string;
    onClick: (newDate: Date) => void;
    initialDate: Date;
    visibleTimeIntervals: TimeInterval[];
}

class ShorthandDateSetter extends BaseReactComponent<IShorthandDateSetterProps> {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "5px 0px 0px 5px" }}>
                {this.renderLinks()}
            </div>
        );
    }

    private renderLinks(): JSX.Element[] {
        return this.props.visibleTimeIntervals
            .map(timeInterval => this.renderLink(timeInterval));
    }

    private renderLink(timeInterval: TimeInterval): JSX.Element {
        return (
            <HyperLinkControl
                dataCy={this.props.dataCy}
                key={`${timeInterval.unit}${timeInterval.value}`}
                text={this.getNameFromTimeInterval(timeInterval)}
                operation={LocalOperations.Unassigned.Unassigned}
                marginLeft="5px"
                onChange={() => this.handleOnClick(timeInterval)}
                className="followup-duedate-link"
            />
        );
    }

    private handleOnClick(timeInterval: TimeInterval): void {
        this.props.onClick(this.getDateInFuture(this.props.initialDate, timeInterval));
    }

    private getDateInFuture(startDate: Date, timeInterval: TimeInterval): Date {
        return new DateOnly(startDate ?? new Date()).plus(timeInterval).toJSDate();
    }

    private getNameFromTimeInterval(timeInterval: TimeInterval): string {
        return `+${timeInterval.value}${timeInterval.getUnitNameLabel()[0].toLowerCase()}`;
    }
}

export { ShorthandDateSetter };
